import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import MonetizationOn from '@material-ui/icons/MonetizationOn';

import Input from '@material-ui/core/Input';

import Paper from '~/components/Paper';
import InputControl from '~/components/Input/InputControl';
import GridContainer from '~/components/GridContainer';
import GridItem from '~/components/GridItem';
import InputSelect from '~/components/Input/InputSelect';

import Form from '~/containers/Form';
import PackRecord from '~/records/PackRecord';
import Request from '~/providers/Request';
import { packageOptions } from '~/config/constants';
import useStyles from './styles';

const attrName = (attr) => PackRecord.hummanAttributeName(attr);

function PackForm({ record, setRecord, handleChange, onSubmit, loading }) {
  const classesRoot = useStyles();
  const { t } = useTranslation();
  const isPersisted = record.isPersisted();

  const [specialtyOptions, setSpecialtyOptions] = useState([]);

  const fetchSpecialties = () => {
    Request.get('/admin/specialties', null, { normalizeJSON: false })
      .then((resp) => {
        const items = resp.data
          .filter((e) => e.attributes && e.attributes.is_active === true)
          .map((e) => ({
            id: Number(e.id),
            name: `${e.attributes.name}`,
          }));
        setSpecialtyOptions(items);
      })
      .catch((e) => {
        console.error(e);
      });
  };

  useEffect(() => {
    fetchSpecialties();
  }, []);

  return (
    <>
      <Form onSubmit={onSubmit}>
        <Paper
          Icon={MonetizationOn}
          iconColor={isPersisted ? 'purple' : 'blue'}
          title={
            isPersisted ? t('packs.extras.edit') : t('packs.extras.create')
          }
          loading={loading}
        >
          <div className={clsx(classesRoot.root)}>
            <GridContainer>
              <GridItem xs={12} sm={6} md={6} lg={6} xl={6}>
                <InputControl
                  name={'name'}
                  value={record.get('name')}
                  label={attrName('name')}
                  required={true}
                  inputComponent={Input}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>
            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputControl
                  name={'description'}
                  value={record.get('description')}
                  label={attrName('description')}
                  inputComponent={Input}
                  InputProps={{
                    multiline: true,
                    rows: '4',
                  }}
                  onChange={handleChange}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputControl
                  name={'packs'}
                  label={attrName('packages')}
                  value={record.get('packs')}
                  inputComponent={InputSelect}
                  onChange={({ packs }) => {
                    setRecord(record.updateAttributes({ packs: packs }));
                  }}
                  InputProps={{
                    isClearable: true,
                    isMulti: true,
                    options: Object.keys(packageOptions)
                      .filter((key) => !['doctor_all', 'pack'].includes(key))
                      .map((key) => ({ id: key, name: packageOptions[key] })),
                  }}
                />
              </GridItem>
            </GridContainer>

            <GridContainer>
              <GridItem xs={12} sm={12} md={12} lg={12} xl={12}>
                <InputControl
                  name={'specialties'}
                  label={attrName('specialties')}
                  value={record.get('specialties')}
                  inputComponent={InputSelect}
                  onChange={({ specialties }) => {
                    setRecord(
                      record.updateAttributes({ specialties: specialties })
                    );
                  }}
                  InputProps={{
                    isClearable: true,
                    isMulti: true,
                    options: specialtyOptions,
                  }}
                />
              </GridItem>
            </GridContainer>
          </div>
        </Paper>
      </Form>
    </>
  );
}

PackForm.propTypes = {
  record: PropTypes.instanceOf(PackRecord).isRequired,
  handleChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  setRecord: PropTypes.func.isRequired,
};

PackForm.defaultProps = {
  loading: false,
};

export default React.memo(withRouter(PackForm));
